<div class="pdfs-chat-settings">
  <div *ngFor="let pdf of pdfFiles" class="wrapper-pdf-preview">
    <div class="info-pdf-previe">
      <img src="../../../../../assets/icons/outline/icon-my-lists.svg" alt="">
      <span>{{pdf.attachment?.name + '.' + pdf.attachment?.extension}}</span>
    </div>
    <img src="../../../../../assets/icons/icon-arrow-left.svg" alt="">
  </div>
</div>
